import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import {
  TAyanasQueryFieldsGetReq,
  TAyanasQueryFieldsGetRes,
  TAyanasQueryGetListReq,
  TAyanasQueryGetListRes,
  TAyanasQueryPostReq,
  TAyanasQueryPutReq,
  TAyanasQueryRes,
  TAyanasQueryRunGetReq,
  TAyanasQueryTablesGetReq,
  TAyanasQueryTablesGetRes,
} from "./TAyanasQuery"

export default class AyanasQueryService extends ConnectApi {
  /**
   * 検索取得
   * @param params
   * @param resolve
   * @param reject
   * @returns
   */
  getList = async (params: TAyanasQueryGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryGetListRes[]>> =
        await this.getInner<TAyanasQueryGetListRes[]>(`/ayanasquery`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   *登録
   * @param params
   * @param resolve
   * @param reject
   * @returns
   */
  post = async (params: TAyanasQueryPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryRes>> =
        await this.postInner(`/ayanasquery`, params)

      return res.data
    } catch (error) {
      throw error
    }
  }
  /**
   * テーブル一覧取得
   * @param params
   * @param resolve
   * @param reject
   * @returns
   */
  getTables = async (params: TAyanasQueryTablesGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryTablesGetRes[]>> =
        await this.getInner<TAyanasQueryTablesGetRes[]>(
          `/ayanasquery/tables`,
          params
        )
      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * フィールド一覧取得
   * @param params
   * @param resolve
   * @param reject
   * @returns
   */
  getFields = async (params: TAyanasQueryFieldsGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryFieldsGetRes[]>> =
        await this.getInner<TAyanasQueryFieldsGetRes[]>(
          `/ayanasquery/fields`,
          params
        )

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * 単体取得
   *
   * @param {string} id ID
   * @memberof UserService
   */
  get = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryRes>> =
        await this.getInner<TAyanasQueryRes>(`/ayanasquery/${id}`, undefined)

      return res.data
    } catch (error) {
      throw error
    }
  }
  /**
   * 単体更新
   *
   * @param {string} id ID
   * @memberof UserService
   */
  put = async (id: string, params: TAyanasQueryPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryRes>> =
        await this.putInner(`/ayanasquery/${id}`, params)

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * 単体削除
   *
   * @param {string} id ID
   * @memberof UserService
   */
  delete = async (id: number) => {
    try {
      const res: AxiosResponse<any> = await this.deleteInner(
        `/ayanasquery/${id}`,
        undefined
      )

      return res.data
    } catch (error) {
      throw error
    }
  }
  /**
   * AyanasQuery実行結果
   * @param id
   * @param resolve
   * @param reject
   * @returns
   */
  getRunResult = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TAyanasQueryRunGetReq>> =
        await this.getInner(`/ayanasquery/run/${id}`, {})

      return res.data
    } catch (error) {
      throw error
    }
  }
}
